/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { bool, func } from "prop-types";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import Avatar from "pages/_components/Avatar";
import CustomText from "pages/_components/CustomText/CustomText";
import { transactionStatus } from "pages/transactions/constants";
import GridTable from "pages/_components/GridTable/GridTable";

const DebinChargebackSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const { data = {}, idTransactionStatus } = transaction;
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const {
        quantity = data.quantity,
        sellerName = data.sellerName,
        debitAccountMask = data.debitAccountMask,
        currency = data.currency,
        issuedDate = data.issuedDate,
        expirationDate = data.expirationDate,
        debinId = data.debinId,
        sellerCbu = data.sellerCbu,
        sellerAlias = data.sellerAlias,
        sellerBank = data.sellerBank,
        sellerBranch = data.sellerBranch,
        concept = data.concept,
        quote = data.quote,
        reference = data.reference,
        envName = data.envName,
        isDesktop = props.isDesktop,
        setShowMoreData = props.setShowMoreData,
        showMoreData = props.showMoreData,
    } = data;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const regexCuota = new RegExp(/^\d{3}\/\d{3}$/);
    const descriptionLabel = regexCuota.test(quote) ? "tableHeader.quota" : "debin.description.label";

    return (
        <div className="ticket__body echeq-endorse">
            <>
                <div className="ticket-header-info">
                    <div className="beneficiary">
                        <div className="avatar-name">
                            <Avatar user={{ userFullName: envName, defaultAvatarId: 0 }} />
                        </div>
                        <div className="user-info">
                            <CustomText className="small" text="echecks.beneficiary" textType="I18N" />
                            <CustomText className="large" text={`${envName} `} />
                        </div>
                    </div>

                    <CustomData
                        dataClass={`amount tag tag-${isPending ? "warning" : idTransactionStatus}`}
                        titleText="debin.amount.label"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={currency} quantity={quantity} />}
                    />
                </div>
                <div className="view-more-data-button" id="element-to-ignore">
                    <div className="ticket__divider divider_1 inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button no-print"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                    <div className="ticket-section">
                        <div
                            style={{
                                display: "block",
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}>
                            <GridTable>
                                <GridTable.Container className="ticket-gap">
                                    <GridTable.Data columnStart={1} rowStart={1}>
                                        <CustomData
                                            titleText="debin.seller"
                                            titleTextType="I18N"
                                            valueText={sellerName}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={2} alignY="flex-start">
                                        <CustomData
                                            titleText="debin.alias"
                                            titleTextType="I18N"
                                            valueText={sellerAlias}
                                        />
                                    </GridTable.Data>

                                    <GridTable.Data columnStart={1} rowStart={3}>
                                        <CustomData titleText="debin.cbu" titleTextType="I18N" valueText={sellerCbu} />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={4}>
                                        <CustomData
                                            titleText="debin.bank.branch"
                                            titleTextType="I18N"
                                            valueText={`${sellerBank}/${sellerBranch}`}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={1}>
                                        <CustomData
                                            titleText="debin.dateExpitation"
                                            titleTextType="I18N"
                                            valueText={debitAccountMask}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={2}>
                                        <CustomData
                                            titleText="debin.expirery.date"
                                            titleTextType="I18N"
                                            valueText={
                                                <FormattedDate date={expirationDate} dateFormat="DD/MM/YYYY HH:mm:ss" />
                                            }
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={3}>
                                        <CustomData
                                            titleText="debin.solicit.date"
                                            titleTextType="I18N"
                                            valueText={
                                                <FormattedDate date={issuedDate} dateFormat="DD/MM/YYYY HH:mm:ss" />
                                            }
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </div>{" "}
                        <div className="ticket__divider divider_2 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <div
                            className="aditional-data"
                            style={{
                                width: "100%",
                            }}>
                            <CustomData
                                titleText="debin.id"
                                titleTextType="I18N"
                                valueText={debinId} // comment
                            />
                            <CustomData
                                titleText={descriptionLabel}
                                titleTextType="I18N"
                                valueText={quote} // comment
                            />
                            <CustomData titleText="debin.concept.label" titleTextType="I18N" valueText={concept} />
                            <CustomData titleText="debin.reference" titleTextType="I18N" valueText={reference} />
                        </div>
                        <TransactionSign
                            noDate={false} // solo funciona cuando esta pending
                            creationTime // muestra la fecha de creacion debajo del firmante
                            isSmall
                            hasSignatures // solo funciona cuando es finished
                            customText="forms.transaction.ticket.dateAndHour"
                            isDesktop={isDesktop}
                            showMoreData={showMoreData}
                            hasVoucherInPending
                            hasVaucher
                        />
                    </div>
                </div>
            </>
        </div>
    );
};

DebinChargebackSummaryBody.propTypes = {
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

DebinChargebackSummaryBody.defaultProps = {
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => {},
};

export default DebinChargebackSummaryBody;
